import {
  CMSPageLoad,
  FaqsPageLoad,
  ProcedureCreateFormPage,
  ProcedureDetailsPage,
  ProposalCreateFormPage,
  ProposalCreatePageLoad,
  ProposalNewCreatePage,
  ProposalWrapperPageLoad
} from '@/modules/home/pages';
import {MyProposalRequestPageLoad} from '@/modules/proposalRequest/pages';

export default {
  NewCreateProposal: {
    exact: true,
    path: '/new-proposal',
    component: ProposalNewCreatePage
  },
  CreateProposal: {
    exact: true,
    path: '/proposal',
    component: ProposalCreatePageLoad
  },
  MyProposalRequests: {
    exact: true,
    path: '/my-proposals',
    permissions: ['REQUEST:READ'],
    component: MyProposalRequestPageLoad
  },
  ProposalRequestsCreate: {
    exact: true,
    path: '/requests/create',
    component: ProposalCreateFormPage,
  },
  EditProposal: {
    exact: true,
    path: '/proposal/:id/edit',
    component: ProposalCreatePageLoad
  },
  ProposalDetails: {
    exact: false,
    path: '/proposal/:id',
    component: ProposalWrapperPageLoad
  },
  ProcedureCreateFormPageLoad: {
    exact: false,
    path: '/company/:id/procedure/create',
    component: ProcedureCreateFormPage,
  },
  ProcedureEditFormPageLoad: {
    exact: false,
    path: '/company/:id/procedure/:procedureId/edit',
    component: ProcedureCreateFormPage,
  },
  ProcedureDetailPageLoad: {
    exact: false,
    path: '/company/procedures/:id',
    component: ProcedureDetailsPage,
  },
  FAQs: {
    exact: true,
    path: '/preguntas-frecuentes',
    component: FaqsPageLoad
  },
  Home: {
    exact: true,
    path: '/',
    component: CMSPageLoad
  },
};
